export default __webpack_public_path__ + "static/fonts/ABCDiatypeRounded-Medium_6NDxMg.woff2";